

































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "imports-provider": () =>
      import("@/components/app/admin/imports/importsProvider.vue"),
    "imports-listing": () =>
      import("@/components/app/admin/imports/importsListing.vue")
  }
})
export default class ImportListingComp extends Vue {
  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise", "div"].includes(tag)
  })
  public readonly tag!: "u-aside" | "u-section-box" | "u-contextualise" | "div";
}
